/**
 * RS Works logo — horizontal lockup or mark-only (collapsed sidebar / favicon contexts).
 */
import { BRAND_ASSETS } from './brandAssets';

const HORIZONTAL = {
  light: BRAND_ASSETS.horizontalLight,
  dark: BRAND_ASSETS.horizontalDark,
};

const MARK = {
  light: BRAND_ASSETS.markLight,
  dark: BRAND_ASSETS.markDark,
};

export default function BrandLogo({
  variant = 'horizontal',
  theme = 'light',
  className,
  alt = 'RS Works',
  ...rest
}) {
  const src = variant === 'mark' ? MARK[theme] : HORIZONTAL[theme];
  return <img src={src} alt={alt} className={className} {...rest} />;
}
